import Tab from 'components/Tab/Tab.f';

export default Tab;
